(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

function sleep(millisecondsToWait) {
    var now = new Date().getTime();
    while (new Date().getTime() < now + millisecondsToWait) {
        /* do nothing; this will exit once it reaches the time limit */
        /* if you want you could do something and exit */
    }
}

$(function () {
    var reCaptchaKey = $('#reCaptchaKey').val();
    $('#password').on('keypress', function (event) {
        if (event.which === 13) {
            $('.submitBtn').trigger('click');
        }
    });

    $('.submitBtn').on('click', function () {
        var btn = $(this);
        var action = $(this).data('action');
        var form = $(this).closest('form');
        var data = form.serialize();
        btn.attr('disabled', true);
        form.find('[name="g-recaptcha-token"]').val('');
        grecaptcha.ready(function () {
            grecaptcha.execute(reCaptchaKey, { action: action }).then(function (token) {
                // Verify the token on the server.
                form.find('[name="g-recaptcha-token"]').val(token);
            });
        });
        var timePress = 10;
        if (form.get(0).checkValidity()) {
            setTimeout(function () {
                var checkToken = setInterval(doSubmit, 10);
                function doSubmit() {
                    if (form.find('[name="g-recaptcha-token"]').val() !== '') {
                        clearInterval(checkToken);
                        form.submit();
                        return true;
                    } else {
                        timePress += 10;
                    }
                }
            }, 0);
        } else {
            var invalids = form.find(':invalid');
            var $invalid = $(invalids[0]);
            $invalid.focus();
            $invalid.focus();
            $invalid.on('change', function () {
                $(this).css('border-color', '');
            });
            invalids[0].reportValidity();
            btn.attr('disabled', false);
            return false;
        }
    });
});

},{}]},{},[1]);
